import React from "react";
import { Modal, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Speaker } from "../../../../../types/scheduling/weekend";

interface SpeakerInfoModalProps {
  speaker: Speaker;
  show: boolean;
  setShow: (show: boolean) => void;
}

export const SpeakerInfoModal: React.FC<SpeakerInfoModalProps> = (props) => {
  const { t } = useTranslation();
  const handleClose = () => props.setShow(false);

  return (
    <Modal show={props.show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("schedules.weekend.speaker-info")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped hover>
          <tbody>
            <tr key="speaker_name">
              <td>{t("general.name")}</td>
              <td>
                {`${props.speaker?.firstname}
                  ${props.speaker?.middlename ?? ""}
                  ${props.speaker?.lastname}
                  ${props.speaker?.suffix ?? ""}`}
              </td>
            </tr>
            <tr key="cell_phone" hidden={!props.speaker?.cellphone}>
              <td>{t("userinfo.cellphone")}</td>
              <td>{props.speaker?.cellphone}</td>
            </tr>
            <tr key="home_phone" hidden={!props.speaker?.homephone}>
              <td>{t("userinfo.homephone")}</td>
              <td>{props.speaker?.homephone}</td>
            </tr>
            <tr key="other_phone" hidden={!props.speaker?.otherphone}>
              <td>{t("userinfo.otherphone")}</td>
              <td>{props.speaker?.otherphone}</td>
            </tr>
            {!!props.speaker?.email && (
              <tr key="email">
                <td>{t("userinfo.email")}</td>
                <td>
                  <a href={`mailto:${props.speaker?.email}`}>{props.speaker?.email}</a>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
};
